import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIncompleteIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_19616_17)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.875 10.625L8.75 12.5L13.125 8.125",
				stroke: "#B40030",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.8587 3.62449C12.9995 3.1079 12.0221 2.75614 10.9643 2.61849C6.85685 2.08393 3.09372 4.98037 2.55916 9.08787C2.0246 13.1954 4.92105 16.9585 9.02854 17.4931C11.8825 17.8645 14.5702 16.5795 16.1242 14.3828",
				stroke: "#B40030",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17 10.95C17.1381 10.95 17.25 11.0619 17.25 11.2C17.25 11.338 17.1381 11.45 17 11.45C16.8619 11.45 16.75 11.338 16.75 11.2C16.75 11.0619 16.8619 10.95 17 10.95Z",
				fill: "#B40030",
				stroke: "#B40030",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17 2V8.1131",
				stroke: "#B40030",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_19616_17",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgIncompleteIcon;
